module.exports = __webpack_public_path__ + "static/media/FJI.cb2f8578.png";